import { AxiosInstance } from 'axios';

const getE2EAxiosInterceptors = () => {
  // window.e2eAxiosInterceptors is only set by the cypress test and is undefined in production mode
  return (
    (window as any).e2eAxiosInterceptors || {
      requestInterceptor: (config: any) => config,
      fulfilledInterceptor: (res: any) => res,
      errorInterceptor: (error: any) => {
        throw error;
      },
    }
  );
};

/**
 * Cypress's intercept functionality is used to mock ALL api requests.  This uses stubbing for all requests.
 * There are edge cases where the stubbing is brought down in between mocha tests, but requests still are sent.
 * This results in an unstubbed test.  This middleware helps synchronize the api requests with the tests.
 *
 * Note that if not running in an e2e environment, this middleware has no effect.
 */
const withE2ERequestStubbing = (axios: AxiosInstance): AxiosInstance => {
  axios.interceptors.request.use(config =>
    getE2EAxiosInterceptors().requestInterceptor(config),
  );

  axios.interceptors.response.use(
    res => getE2EAxiosInterceptors().fulfilledInterceptor(res),
    err => getE2EAxiosInterceptors().errorInterceptor(err),
  );
  return axios;
};

export default withE2ERequestStubbing;
